import React, { Component } from 'react';
// import mtl from 'mtl-js-sdk';
import { changeStatus } from "apis/material";
import { calculationDist, compressImage } from "common/util";
// import { Toast } from 'antd-mobile';
import { AutoCenter, Button, Dialog, Divider, ImageUploader, Space, Toast } from 'antd-mobile-v5';
import './index.less';

export default class Sign extends Component {

    constructor(props) {
        super(props);
        this.state = {
            addressCode: 0,      // 0 代表正在定位中，1 代表定位成功，2 表示定位失败
            longitude: null,
            latitude: null,
            centerLat: null,
            centerLng: null,
            nradius: null,
            ImageUploadItem: []
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.longitude !== this.state.longitude || this.props.latitude !== this.state.latitude) {
            const { materialData, longitude, latitude } = this.props;
            let info = materialData?.deliveryBodys[0];
            let centerLng,
                centerLat,
                nradius;
            if (materialData?.vbilltypecode && materialData?.vbilltypecode === "4EAB") {
                centerLng = info?.vsendaddress?.nlongitude;
                centerLat = info?.vsendaddress?.nlatitude;
                nradius = info?.vsendaddress?.nradius;
            } else if (materialData?.vbilltypecode && materialData?.vbilltypecode === "4EAC") {
                centerLng = info?.vreceiveaddress?.nlongitude;
                centerLat = info?.vreceiveaddress?.nlatitude;
                nradius = info?.vreceiveaddress?.nradius;
            }
            this.setState({
                longitude,
                latitude,
                centerLng,
                centerLat,
                nradius
            })
            this.getLocationInfo(centerLng, centerLat, longitude, latitude, nradius);
        } else if ((this.props.longitude === this.state.longitude || this.props.latitude === this.state.latitude) && prevState.addressCode !== this.state.addressCode) {
            const { longitude, latitude, centerLat, centerLng, nradius } = this.state;
            setTimeout(() => {
                this.getLocationInfo(centerLng, centerLat, longitude, latitude, nradius);
            }, 3000)
        }
    }

    getLocationInfo = (centerLng, centerLat, longitude, latitude, nradius) => {
        let result = calculationDist(centerLng, centerLat, longitude, latitude);
        if (result) {
            if (result > nradius) {
                // 超出电子围栏范围则显示未签到
                this.setState({
                    addressCode: 2
                })
            } else {
                this.setState({
                    addressCode: 1
                })
            }
        }
    }

    signIn = () => {
        const { materialData, getCurrentSignInfo } = this.props;
        let param = {
            action: "3",
            appid: "",
            param: {
                pk_delivery: materialData?.pk_delivery,
                pk_stockorg: materialData?.stockorg?.pk_org
            }
        }
        let result = changeStatus(param);
        result.then(res => {
            if (res) {
                if (res.statuscode === '0') {
                    let statusCode = res?.datas?.lineStatus?.code;
                    if (statusCode && statusCode === "1") {
                        Toast.show("签到成功！");
                        getCurrentSignInfo(res.datas);
                    }
                } else {
                    Toast.fail("签到失败：" + res.errinfo, 5);
                }
            }
        })
    }

    refreshAddress = () => {
        const { getLocationRefresh } = this.props;
        this.setState({
            addressCode: 0
        })
        getLocationRefresh(true);
    }

    render() {
        const { addressCode, ImageUploadItem } = this.state;
        const { getDetailInfo, getAllMaterial, materialData, pkDelivery, pkOrg, picconf } = this.props;
        let showIcon = addressCode === 2 ? "none" : "block";

        let addressContent;
        switch (addressCode) {
            case 0:
                addressContent = <div>定位中...</div>;
                break;
            case 1:
                addressContent = <div>签到地点：{materialData?.stockorg?.name}</div>;
                break;
            case 2:
                addressContent = <div onClick={this.refreshAddress}><div>重新定位</div><div className="address-refresh"></div></div>;
                break;
            default:
                break;
        }

        return (
            <div className="body-sign">
                {
                    addressCode === 0
                        ? <div className="locate"><div className="locate-text">定位中</div></div>
                        : addressCode === 2
                            ? <div className="unsign"><div className="unsign-text"><div>未在</div><div>签到范围内</div></div></div>
                            : <div onClick={this.signIn} className="sign"><div className="sign-text">签到</div></div>
                }
                {/* <div onClick={this.signIn} className="sign"><div className="sign-text">签到</div></div> */}
                <div className="body-sign-address">
                    <div className="address-img" style={{ display: showIcon }}></div>
                    <div className="address-content">{addressContent}</div>
                </div>
                <Divider />
                <Space justify='center' block>
                    <Button
                        onClick={async () => {
                            const conf = await Dialog.confirm({
                                content: '是否确认取消预约？',
                            });
                            if (conf) {
                                let paramData = {
                                    action: "7",
                                    appid: "",
                                    param: {
                                        pk_stockorg: pkOrg,
                                        pk_org: pkOrg,
                                        pk_thd: pkDelivery,
                                        cph: materialData.vlicense
                                    }
                                }
                                let result = getAllMaterial(paramData);
                                result.then(res => {
                                    if (res.statuscode === '0') {
                                        Toast.show(res.datas.message);
                                        getDetailInfo();
                                    }
                                });
                            }
                        }}
                        shape='rounded'
                        color='primary'>
                        取消预约
                    </Button>
                    {/* <Button  shape='rounded' color='primary'>
                    图片上传
                </Button> */}
                </Space>
                <Divider />
                <Space> <AutoCenter
                    style={{ color: '#697b8c', fontSize: '14px' }}
                >{picconf}</AutoCenter></Space>
                <ImageUploader
                    value={ImageUploadItem}
                    onChange={(items) => {
                        this.setState({
                            ImageUploadItem: items
                        });
                        console.log(ImageUploadItem);
                        console.log(items);
                    }}
                    beforeUpload={async (file, files) => {
                        console.log(file.size, '----------------未压缩的尺寸')
                        // 在这里进行压缩处理
                        const compressedFile = await compressImage(file)
                        console.log(compressedFile.size, '--------------------压缩后的尺寸')
                        // 返回压缩后的文件，供后续 upload 方法使用
                        return compressedFile
                    }}
                    upload={(file) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function (event) {
                            let paramData = {
                                action: "8",
                                appid: "",
                                param: {
                                    pk_stockorg: pkOrg,
                                    pk_org: pkOrg,
                                    pk_delivery: pkDelivery,
                                    filename: file.name,
                                    filebase64: event.target.result
                                }
                            }
                            let result = getAllMaterial(paramData);
                            result.then(res => {
                                if (res.statuscode === '0') {
                                    Toast.show(res.datas.message);
                                    // getDetailInfo();
                                } else {
                                    Toast.fail("上传失败：" + res.errinfo, 5);
                                }

                            })
                        }
                        return {
                            url: URL.createObjectURL(file)
                        }
                    }}
                    multiple={"ture"}
                    maxCount={8}
                    onCountExceed={exceed => {
                        Toast.show(`最多选择8张图片，你多选了 ${exceed} 张`)
                    }}
                />
            </div>
        )
    }
}

